import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { howLongAgo } from '@fiverr-private/futile/lib/datetime';
import { FiverrContext } from '@fiverr-private/fiverr_context';
import { DEFAULT_LOCALE } from '@fiverr-private/fiverr_context/lib/constants';
import I18n from '@fiverr-private/fiverr_context/src/I18n';

import './index.scss';

const GigReview = ({ compact, buyerName, buyerProfilePicture, text, ratingValue, createdAt }) => {
    const { locale = DEFAULT_LOCALE } = useContext(FiverrContext);

    const getTimeAgo = () => {
        const dateCreatedAt = new Date(createdAt),
            isInvalidDate = isNaN(dateCreatedAt);

        return isInvalidDate ? null : howLongAgo(dateCreatedAt, {prefix:'gig_page_perseus.general.how_long_ago.', locale});
    };

    const renderAvatar = () => {
        const initial = (buyerName || ' ').substr(0, 1); // Get the buyer's username first letter
        const element = buyerProfilePicture ?
            <img src={buyerProfilePicture} alt={buyerName} width="128" height="128"/> :
            <span className="missing-image-user">{initial}</span>;

        return (element);
    };

    const renderCompactReview = () => (
        <footer className="gig-review compact">
            <blockquote>{ text }</blockquote>
            <small><I18n k={'gig_page_perseus.gallery.reviewed_by'}/> { buyerName } { getTimeAgo() }</small>
        </footer>
    );

    const renderFullReview = () => {
        const buyerProfileUrl = `/${buyerName}`,
            roundedRating = Math.round(ratingValue*2),
            ago = getTimeAgo();

        return (
            <footer className="gig-review">
                <figure className="gig-review-avatar">
                    {renderAvatar()}
                </figure>
                <a className="gig-review-user" href={buyerProfileUrl}>{ buyerName }</a>
                <span className={`gig-review-rating star-rating-s12 rate-${roundedRating}`}/>
                <small className="gig-review-ago">{ ago }</small>
                <blockquote className="gig-review-comment">{ text }</blockquote>
            </footer>
        );
    };

    return compact ?
        renderCompactReview() :
        renderFullReview();
};

GigReview.propTypes = {
    compact: PropTypes.bool,
    buyerName: PropTypes.string.isRequired,
    buyerProfilePicture: PropTypes.string,
    text: PropTypes.string.isRequired,
    ratingValue: PropTypes.number.isRequired,
    createdAt: PropTypes.string
};

GigReview.defaultProps = {
    compact: false
};

export default GigReview;
